(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["igs-bundle-closing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('igs-bundle-closing')) {
    customElements.define('igs-bundle-closing', class extends HTMLElement {
      connectedCallback() {
        this.form = document.querySelector(`form[data-product-handle="${this.dataset.productHandle}"]`);
        this.formId = this.form?.getAttribute('id');
        this.source = this.form?.closest('[data-section-type="product"]');
        if (!this.source) return;
        this.action = this.querySelector('[data-bundle-closing-add]');
        this.price = this.querySelector('[data-closing-price]');
        this.error = this.querySelector('[data-closing-error]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.schedule = () => { if (this.frame) return; this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); }); };
        this.source.addEventListener('input', this.schedule, options);
        this.source.addEventListener('change', this.schedule, options);
        this.action.addEventListener('click', () => {
          const form = document.getElementById(this.formId);
          const original = form?.querySelector('[data-add-to-cart]');
          if (!original || original.disabled || original.classList.contains('loading')) return;
          if (!form.reportValidity()) { form.querySelector(':invalid')?.scrollIntoView({ block: 'center' }); return; }
          this.pending = true; this.error.textContent = ''; this.error.hidden = true;
          original.click(); this.sync();
        }, options);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.source, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'value'] });
        this.schedule();
      }
      sync() {
        const form = document.getElementById(this.formId);
        const original = form?.querySelector('[data-add-to-cart]');
        if (!original) { this.action.disabled = true; return; }
        const loading = original.classList.contains('loading');
        const success = original.classList.contains('has-success');
        this.action.disabled = original.disabled;
        this.action.setAttribute('aria-busy', String(loading));
        this.action.classList.toggle('loading', loading); this.action.classList.toggle('has-success', success);
        this.querySelector('.product__form__outer').classList.toggle('product__form--buybutton', Boolean(original.closest('.product__form--buybutton')));
        if (this.markup !== original.innerHTML) { this.markup = original.innerHTML; this.action.replaceChildren(...Array.from(original.childNodes, node => node.cloneNode(true))); }
        this.action.setAttribute('aria-label', original.querySelector('.btn-state-ready')?.textContent.trim() || original.textContent.trim());
        const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
        const price = this.source.querySelector('.product__price')?.textContent.trim();
        if (price) this.price.textContent = `${quantity > 1 ? `${quantity} × ` : ''}${price}`;
        if (success) this.pending = false;
        if (this.pending && !loading && !original.disabled) {
          const error = form.querySelector('[data-add-action-errors]')?.textContent.trim();
          if (error) { this.error.textContent = error; this.error.hidden = false; this.pending = false; }
        }
      }
      disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igs-bundle-discover"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('igs-bundle-discover')) {
    customElements.define('igs-bundle-discover', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.tabsets = new Map();
        this.momentCleanup = null;
        this.querySelectorAll('[data-tabset]').forEach(set => {
          const list = set.querySelector('[data-tablist]');
          const tabs = Array.from(list.querySelectorAll('[data-tab]'));
          const panels = Array.from(set.querySelectorAll('[data-panel]'));
          let visual = null;
          const activate = (key, focus = false, scroll = true) => {
            tabs.forEach(tab => { const selected = tab.dataset.tab === key; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; if (selected && focus) tab.focus({ preventScroll: true }); });
            if (visual) visual.select(key, scroll);
            else panels.forEach(panel => { panel.hidden = panel.dataset.panel !== key; });
          };
          list.setAttribute('role', 'tablist');
          tabs.forEach((tab, index) => {
            tab.setAttribute('role', 'tab');
            const panel = panels.find(p => p.id === tab.getAttribute('aria-controls'));
            if (panel) { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id); panel.tabIndex = 0; }
            tab.addEventListener('click', () => activate(tab.dataset.tab), options);
            tab.addEventListener('keydown', event => {
              const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : event.key === 'ArrowLeft' ? (index - 1 + tabs.length) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null;
              if (next === null) return;
              event.preventDefault(); activate(tabs[next].dataset.tab, true);
            }, options);
          });
          if (set.hasAttribute('data-moment-set')) visual = this.setupMoments(set, tabs, panels, activate, options);
          activate(set.dataset.initial || tabs[0]?.dataset.tab);
          list.hidden = false;
          const hint = set.querySelector('[data-tab-hint]');
          if (hint) hint.hidden = false;
          set.querySelectorAll('[data-switch-tab]').forEach(button => {
            if (!tabs.some(tab => tab.dataset.tab === button.dataset.switchTab)) return;
            button.hidden = false;
            button.addEventListener('click', () => {
              activate(button.dataset.switchTab, true);
              list.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            }, options);
          });
          this.tabsets.set(set, activate);
        });
        this.querySelectorAll('[data-book]').forEach(book => {
          const pages = Array.from(book.querySelectorAll('[data-page]'));
          const controls = book.querySelector('[data-book-controls]');
          const counter = book.querySelector('[data-book-counter]');
          const previous = book.querySelector('[data-book-prev]');
          const next = book.querySelector('[data-book-next]');
          const enlarge = book.querySelector('[data-enlarge-current]');
          let current = 0;
          const show = index => {
            current = Math.max(0, Math.min(index, pages.length - 1));
            pages.forEach((page, i) => { page.hidden = i !== current; });
            counter.textContent = counter.dataset.template.replace('[current]', current + 1).replace('[total]', pages.length);
            previous.disabled = current === 0; next.disabled = current === pages.length - 1;
          };
          if (pages.length) {
            show(0); controls.hidden = pages.length < 2; enlarge.hidden = false;
            previous.addEventListener('click', () => show(current - 1), options);
            next.addEventListener('click', () => show(current + 1), options);
            enlarge.addEventListener('click', () => pages[current].click(), options);
          }
        });
        this.dialog = this.querySelector('[data-image-dialog]');
        this.querySelectorAll('[data-page]').forEach(link => link.addEventListener('click', event => {
          if (!this.dialog.showModal) return;
          event.preventDefault();
          this.returnFocus = document.activeElement;
          const image = this.dialog.querySelector('[data-dialog-image]');
          image.src = link.href; image.alt = link.querySelector('img').alt;
          this.dialog.querySelector('[data-dialog-caption]').textContent = image.alt;
          this.dialog.showModal();
          if (!document.documentElement.hasAttribute('data-scroll-locked')) {
            this.ownsScrollLock = true;
            document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.dialog }));
          }
        }, options));
        this.dialog.querySelector('[data-close-dialog]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.unlock();
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-panel]');
          if (panel && this.contains(panel)) this.tabsets.get(panel.closest('[data-tabset]'))?.(panel.dataset.panel);
        }, options);
        this.classList.add('is-enhanced');
      }
      setupMoments(set, tabs, panels, activate, options) {
        if (tabs.length < 2 || panels.some(panel => !panel.querySelector('.igs-bundle-discover__image'))) return null;
        const stage = set.querySelector('[data-moment-stage]');
        const visual = set.querySelector('[data-moment-visual]');
        const track = set.querySelector('[data-moment-track]');
        const counter = set.querySelector('[data-moment-counter]');
        const previous = set.querySelector('[data-moment-prev]');
        const next = set.querySelector('[data-moment-next]');
        const mobile = matchMedia('(max-width: 749px)');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let current = 0;
        let timer;
        let moving = false;
        let frame;
        const align = (smooth = false) => {
          if (!mobile.matches || !track.clientWidth) return;
          const card = panels[current];
          const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - (track.clientWidth - card.offsetWidth) / 2;
          track.scrollTo({ left, behavior: smooth && !reduced.matches ? 'smooth' : 'instant' });
        };
        const select = (key, scroll = true) => {
          const index = panels.findIndex(panel => panel.dataset.panel === key);
          if (index < 0) return;
          current = index;
          panels.forEach((panel, i) => {
            panel.inert = i !== current;
            panel.hidden = !mobile.matches && i !== current;
          });
          counter.textContent = counter.dataset.template.replace('[current]', current + 1).replace('[total]', panels.length);
          previous.setAttribute('aria-disabled', String(current === 0));
          next.setAttribute('aria-disabled', String(current === panels.length - 1));
          if (scroll) align(true);
        };
        const sync = () => {
          clearTimeout(timer);
          if (!mobile.matches || !track.clientWidth) return;
          const center = track.getBoundingClientRect().left + track.clientWidth / 2;
          let nearest = 0;
          let distance = Infinity;
          panels.forEach((panel, i) => {
            const rect = panel.getBoundingClientRect();
            const delta = Math.abs(rect.left + rect.width / 2 - center);
            if (delta < distance) { distance = delta; nearest = i; }
          });
          activate(panels[nearest].dataset.panel, false, false);
          frame = requestAnimationFrame(() => { moving = false; });
        };
        track.addEventListener('scroll', () => { moving = true; clearTimeout(timer); timer = setTimeout(sync, 160); }, { ...options, passive: true });
        track.addEventListener('scrollend', sync, options);
        previous.addEventListener('click', () => { if (current > 0) activate(panels[current - 1].dataset.panel); }, options);
        next.addEventListener('click', () => { if (current < panels.length - 1) activate(panels[current + 1].dataset.panel); }, options);
        track.addEventListener('click', event => {
          if (!mobile.matches || moving) return;
          const neighbour = panels.find(panel => {
            if (!panel.inert) return false;
            const rect = panel.getBoundingClientRect();
            return event.clientX >= rect.left && event.clientX < rect.right;
          });
          if (neighbour) activate(neighbour.dataset.panel);
        }, options);
        mobile.addEventListener('change', () => {
          select(panels[current].dataset.panel, false);
          align();
        }, options);
        let lastWidth;
        const observer = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width === lastWidth) return;
          lastWidth = entry.contentRect.width;
          align();
        });
        observer.observe(track);
        visual.hidden = false;
        stage.classList.add('is-ready');
        set.classList.add('has-swipe');
        this.momentCleanup = () => {
          clearTimeout(timer); cancelAnimationFrame(frame); observer.disconnect();
          panels.forEach(panel => { panel.hidden = false; panel.inert = false; });
          visual.hidden = true; stage.classList.remove('is-ready'); set.classList.remove('has-swipe');
        };
        return { select };
      }
      unlock() {
        if (this.ownsScrollLock) document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
        this.ownsScrollLock = false;
      }
      disconnectedCallback() {
        this.dialog?.close(); this.unlock(); this.events?.abort(); this.momentCleanup?.(); this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igs-home-books"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-igs-book-zoom]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.getElementById(link.dataset.igsBookZoom);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    dialog.showModal();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["igs-system-example"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-igs-system-zoom]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.getElementById(link.dataset.igsSystemZoom);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    dialog.showModal();
  });

  } catch(e) { console.error(e); }
})();
})();
